import React, { useEffect } from 'react'
import classNames from 'classnames'
import { connect } from 'react-redux'

import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { AppState, RootState, Dispatcher } from 'AppTypes'

import { LoadingSpinner } from '@share/components'
import { toggleGlobalLoading } from '@app/state_management/actions'
import { useDidMountRef } from '@utils'

type Props = {
  appState: AppState
  dispatch: Dispatcher
}

const StoreManagement: React.FC<Props> = ({
  appState,
  dispatch
}) => {
  const isMounted = useDidMountRef()

  if (!isMounted) {
    dispatch(toggleGlobalLoading(true))

    setTimeout(() => {
      dispatch(toggleGlobalLoading(false))
    }, 1000)
  }

  const { t } = useTranslation()
  // V.A IS IN PROGRESS
  return (
    <div className="main-content p-0">
      <LoadingSpinner />
      <ul className="nav nav-tabs" id="StoreInformationTab" role="tablist">
        <li className="nav-item">
          <a className="nav-link active" id="StoreInformation-BasicInformation-tab" data-toggle="tab" href="#StoreInformation-BasicInformation" role="tab" aria-controls="BasicInformation" aria-selected="true">基本情報</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="StoreInformation-PriceRangeCategory-tab" data-toggle="tab" href="#StoreInformation-PriceRangeCategory" role="tab" aria-controls="PriceRangeCategory" aria-selected="false">価格帯・カテゴリ</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="StoreInformation-ReviewsManagement-tab" data-toggle="tab" href="#StoreInformation-ReviewsManagement" role="tab" aria-controls="ReviewsManagement" aria-selected="false">口コミ管理</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" id="StoreInformation-LatestInformationManagement-tab" data-toggle="tab" href="#StoreInformation-LatestInformationManagement" role="tab" aria-controls="LatestInformationManagement" aria-selected="false">最新情報</a>
        </li>
      </ul>
      <div className="tab-content" id="StoreInformationTabContent">
        {/* <!-- Store information - basic information --> */}
        <div className="tab-pane fade show active" id="StoreInformation-BasicInformation" role="tabpanel" aria-labelledby="StoreInformation-BasicInformation-tab">
          <h3>
            <img src="/assets/img/shop-ui_icon_shopinfo-red.png" alt="店舗情報" />
            基本情報
          </h3>
          <div className="row form-group">
            <label className="col-3 col-form-label">店 名</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">支店名</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">フリガナ</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">別名表記</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">電話番号</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <h3 className="mt-4 pl-2">所在地</h3>
          <div className="row form-group">
            <label className="col-3 col-form-label">都道府県</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">市町村・番地</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">ビル名・階数</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">最寄り駅</label>
            <div className="col-9">
              <div className="d-flex align-items-center">
                <div className="autocomplete position-relative" style={{ width: 120 }}>
                  <input className="form-control" id="Station-JP" name="Station-JP" type="text" placeholder="入力してください" />
                </div>
                <label className="col-form-label pl-0 pr-2 text-right" style={{ width: 150 }}>フリースペース</label>
                <input className="form-control" style={{ width: 160 }} type="text" placeholder="入力してください" />
                <div><i className="fas fa-plus-circle icon-add">{' '}</i></div>
              </div>
              <textarea className="form-control mt-2" rows={5} placeholder="地　図" />
            </div>
          </div>

          <h3 className="mt-4 pl-2">定休日・営業時間</h3>
          <div className="row form-group">
            <label className="col-3 col-form-label">営業時間</label>
            <div className="col-9">
              <div className="d-flex align-items-center">
                <input className="form-control" type="time" placeholder="00:00" />
                <label className="col-form-label pl-0"> 〜 </label>
                <input className="form-control" type="time" placeholder="00:00" />
                <i className="fas fa-plus-circle icon-add">{' '}</i>
              </div>
              <div className="d-flex align-items-center">
                <div className="item-color" />
                <div className="item-color" />
                <div className="item-color" />
                <div className="item-color" />
                <div className="item-color" />
                <div className="item-color" />
                <div className="mt-2"><i className="fas fa-long-arrow-alt-left">{' '}</i> 曜日</div>
              </div>
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">定休日</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <h3 className="mt-4 pl-2">詳細情報</h3>
          <div className="row form-group">
            <label className="col-3 col-form-label">予 約</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">支払い方法</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">貸し切り</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">席 数</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">喫 煙</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">駐車場</label>
            <div className="col-8">
              <input className="form-control" type="text" placeholder="入力してください" />
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label">Web・SNS</label>
            <div className="col-9">
              <div className="d-flex align-items-center">
                <input className="form-control" type="text" placeholder="入力してください" />
                <i className="fas fa-plus-circle icon-add">{' '}</i>
              </div>
            </div>
          </div>
          <div className="row form-group">
            <label className="col-3 col-form-label"> </label>
            <div className="col-8">
              <button type="button" className="btn btn-block bg-danger w-100 mt-3">保存</button>
            </div>
          </div>
        </div>
        {/* <!-- End Store information - basic information --> */}

        {/* <!-- Store information - price range category --> */}
        <div className="tab-pane fade" id="StoreInformation-PriceRangeCategory" role="tabpanel" aria-labelledby="StoreInformation-PriceRangeCategory-tab">
          <h3 className="mb-3">価格帯</h3>
          <div className="row form-group">
            <div className="col-3">
              <button type="button" className="btn btn-block bg-danger w-100">ランチ</button>
            </div>
            <div className="col-8">
              <select className="form-control">
                <option selected>選択してください</option>
                <option>...</option>
              </select>
            </div>
          </div>
          <div className="row form-group">
            <div className="col-3">
              <button type="button" className="btn btn-block bg-danger w-100">ディナー</button>
            </div>
            <div className="col-8">
              <select className="form-control">
                <option selected>選択してください</option>
                <option>...</option>
              </select>
            </div>
          </div>
          <div className="row form-group">
            <div className="col-3">
              <button type="button" className="btn btn-block bg-danger w-100">宴会予算</button>
            </div>
            <div className="col-8">
              <select className="form-control">
                <option selected>選択してください</option>
                <option>...</option>
              </select>
            </div>
          </div>
          <hr />
          <h3 className="mb-3">料理のジャンル</h3>
          <div className="form-group mb-4">
            <h4 className="title-cooking-genre mb-2"><span> </span> すし・魚料理寿司</h4>
            <div className="d-flex">
              <button type="button" className="btn btn-general btn-sm mr-1">寿司</button>
              <button type="button" className="btn btn-general btn-sm mr-1">回転寿司</button>
              <button type="button" className="btn btn-general btn-sm mr-1">立ち食い寿司</button>
              <button type="button" className="btn btn-general btn-sm mr-1">魚介料理・海鮮料理</button>
              <button type="button" className="btn btn-general btn-sm mr-1">ふぐ</button>
              <button type="button" className="btn btn-general btn-sm">かに</button>
            </div>
          </div>
          <div className="form-group mb-4">
            <h4 className="title-cooking-genre mb-2"><span> </span> すし・魚料理寿司</h4>
            <div className="d-flex">
              <button type="button" className="btn btn-general btn-sm mr-1">寿司</button>
              <button type="button" className="btn btn-general btn-sm mr-1">回転寿司</button>
              <button type="button" className="btn btn-general btn-sm mr-1">立ち食い寿司</button>
              <button type="button" className="btn btn-general btn-sm mr-1">魚介料理・海鮮料理</button>
              <button type="button" className="btn btn-general btn-sm mr-1">ふぐ</button>
              <button type="button" className="btn btn-general btn-sm">かに</button>
            </div>
          </div>
          <div className="form-group mb-4">
            <h4 className="title-cooking-genre mb-2"><span> </span> すし・魚料理寿司</h4>
            <div className="d-flex">
              <button type="button" className="btn btn-general btn-sm mr-1">寿司</button>
              <button type="button" className="btn btn-general btn-sm mr-1">回転寿司</button>
              <button type="button" className="btn btn-general btn-sm mr-1">立ち食い寿司</button>
              <button type="button" className="btn btn-general btn-sm mr-1">魚介料理・海鮮料理</button>
              <button type="button" className="btn btn-general btn-sm mr-1">ふぐ</button>
              <button type="button" className="btn btn-general btn-sm">かに</button>
            </div>
          </div>
          <hr />
          <h3 className="mb-2">目的・利用シーン</h3>
          <div className="d-flex">
            <button type="button" className="btn btn-general btn-sm mr-1">モーニング</button>
            <button type="button" className="btn btn-general btn-sm mr-1">ブランチ</button>
            <button type="button" className="btn btn-general btn-sm mr-1">ランチ</button>
          </div>
          <h3 className="mb-2 mt-4">目的・利用シーン詳細</h3>
          <div className="note-body">
            <div className="noted" style={{ width: 400 }}>
              { '持案そと異急おるんめ菊沖ミレ選盟へひッ助味いなれほ史止骨だ載方シヨソ玲保クモ報先り案点たぎす地英妻ハメエ少非ぽぐン歌科ミ在重ツスク瀬98設とりぞ奈行票教二ばにぐみ。役ちがだ学中こ小資だぎンな訴集ユ十24味スツヘ賞委六のっちぼ凍散けょぎ情年制ヌ本端クやぎ反構オケ栄香国ロ県9抽まろる。 ' }
            </div>
          </div>
          <hr />
          <h3 className="mb-0 mt-4">空間・設備</h3>
          <div className="d-flex align-items-center">
            <button type="button" className="btn btn-general mr-1">モーニング</button>
            <button type="button" className="btn btn-general mr-1">ブランチ</button>
            <button type="button" className="btn btn-general mr-1">ランチ</button>
            <div className="noted" style={{ width: 265 }}>
              持案そと異急おるんめ菊沖ミレ選盟へひッ助味いなれほ史止骨だ載方シヨソ玲保クモ報先り案点たぎす地英妻ハメエ少非ぽぐン歌科ミ在重ツスク瀬98設とりぞ奈行票教二ばにぐみ。
            </div>
          </div>
          <h3 className="mb-0">ロケーション</h3>
          <div className="d-flex align-items-center">
            <button type="button" className="btn btn-general mr-1">景色がきれい</button>
            <div className="noted" style={{ width: 265 }}>
              条ツソルシ犬戦ヒエ談合ら節済熱リ話通えめス済所こ分園らふとげ筆特リ
            </div>
          </div>
          <h3 className="mb-0 mt-4">サービス</h3>
          <div className="d-flex align-items-center">
            <button type="button" className="btn btn-general mr-1">お祝い・サプライズOK</button>
            <div className="noted" style={{ width: 365 }}>
              条ツソルシ犬戦ヒエ談合ら節済熱リ話通えめス済所こ分園らふとげ筆特リカムホ投世ミヘ党務めだぱ囲球危たんめお拍済ぐうゅの督需館歯ド
            </div>
          </div>
          <div className="mt-4 text-center"><button type="button" className="btn bg-danger w-75">保存</button></div>
        </div>
        {/* <!-- EndStore information - price range category --> */}

        {/* <!-- Store information - Reviews management --> */}
        <div className="tab-pane fade" id="StoreInformation-ReviewsManagement" role="tabpanel" aria-labelledby="StoreInformation-ReviewsManagement-tab">
          <h3 className="mb-3">口コミ一覧</h3>
          <div className="row form-group">
            <label className="col-3 col-form-label">フィルタ</label>
            <div className="col-8">
              <select className="form-control w-50">
                <option selected>選択してください</option>
                <option>...</option>
              </select>
            </div>
          </div>
          <div className="review-items">
            <div className="rates d-flex mt-4">
              <div className="rate-star ml-5 mr-3">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
              <div>2021/5/1 15:00</div>
            </div>
            <div className="d-flex align-items-center">
              <div className="custom-control custom-checkbox ml-3 mr-4">
                <input type="checkbox" className="custom-control-input" id="customCheck1" name="example1" />
                <label className="custom-control-label"> </label>
              </div>
              <img src="/assets/img/avatar.jpg" className="rounded-circle mr-3" alt="" />
              <div className="review-text">
                HAPPY さん (口コミ 50件) <br />
                とってもおいしいです！よかったです！ <br />
                また行きたいです！
              </div>
              <img src="/assets/img/menu.jpg" className="rounded" alt="" width="79px" />
            </div>
          </div>
          <div className="review-items">
            <div className="rates d-flex mt-4">
              <div className="rate-star ml-5 mr-3">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
              <div>2021/5/1 15:00</div>
            </div>
            <div className="d-flex align-items-center">
              <div className="custom-control custom-checkbox ml-3 mr-4">
                <input type="checkbox" className="custom-control-input" id="customCheck2" name="example2" />
                <label className="custom-control-label"> </label>
              </div>
              <img src="/assets/img/avatar.jpg" className="rounded-circle mr-3" alt="" />
              <div className="review-text">
                HAPPY さん (口コミ 50件) <br />
                とってもおいしいです！よかったです！ <br />
                また行きたいです！
              </div>
              <img src="/assets/img/menu.jpg" className="rounded" alt="" width="79px" />
            </div>
          </div>
          <div className="review-items">
            <div className="rates d-flex mt-4">
              <div className="rate-star ml-5 mr-3">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
              <div>2021/5/1 15:00</div>
            </div>
            <div className="d-flex align-items-center">
              <div className="custom-control custom-checkbox ml-3 mr-4">
                <input type="checkbox" className="custom-control-input" id="customCheck3" name="example3" />
                <label className="custom-control-label"> </label>
              </div>
              <img src="/assets/img/avatar.jpg" className="rounded-circle mr-3" alt="" />
              <div className="review-text">
                HAPPY さん (口コミ 50件) <br />
                とってもおいしいです！よかったです！ <br />
                また行きたいです！
              </div>
              <img src="/assets/img/menu.jpg" className="rounded" alt="" width="79px" />
            </div>
          </div>
          <div className="review-items">
            <div className="rates d-flex mt-4">
              <div className="rate-star ml-5 mr-3">
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
                <i className="fas fa-star" />
              </div>
              <div>2021/5/1 15:00</div>
            </div>
            <div className="d-flex align-items-center">
              <div className="custom-control custom-checkbox ml-3 mr-4">
                <input type="checkbox" className="custom-control-input" id="customCheck4" name="example4" />
                <label className="custom-control-label"> </label>
              </div>
              <img src="/assets/img/avatar.jpg" className="rounded-circle mr-3" alt="" />
              <div className="review-text">
                HAPPY さん (口コミ 50件) <br />
                とってもおいしいです！よかったです！ <br />
                また行きたいです！
              </div>
              <img src="/assets/img/menu.jpg" className="rounded" alt="" width="79px" />
            </div>
          </div>
          <div className="text-right text-red" style={{ fontSize: 16 }}>
            ＊ GMTS口コミガイドライン
          </div>
          <div className="text-right" style={{ fontSize: 16 }}>
            <i className="fas fa-arrow-alt-circle-right" />
            選択した問題のある口コミをGMTSに削除依頼する
          </div>
        </div>
        {/* <!-- End Store information - Reviews management --> */}

        {/* <!-- Store information - Latest Information Management --> */}
        <div className="tab-pane fade" id="StoreInformation-LatestInformationManagement" role="tabpanel" aria-labelledby="StoreInformation-LatestInformationManagement-tab">
          <h3 className="mb-4">最新情報</h3>
          <div className="d-flex justify-content-between align-items-center mb-3">
            <h3 className="m-0">情報一覧</h3>
            <a href="#" className="btn btn-outline-red">新規追加</a>
          </div>
          <div className="box-items">
            <div className="rate-index">
              <i className="fas fa-star" /> 順位を表示する 1
            </div>
            <div className="title">
              タイトルを表示する
            </div>
            <div className="descriptions">
              任ユヱ細屋ぱすあひ謙個4後トヤロテ真情べせひ三馬ゆちどえ列動掲に似強みえたへ引選い調機ヒヌ妻蔵フんきト地稿ぱごもら前鉾投やねな投木慈スも。
            </div>
          </div>
          <div className="box-items">
            <div className="rate-index">
              <i className="fas fa-star" /> 順位を表示する 2
            </div>
            <div className="title">
              タイトルを表示する
            </div>
            <div className="descriptions">
              任ユヱ細屋ぱすあひ謙個4後トヤロテ真情べせひ三馬ゆちどえ列動掲に似強みえたへ引選い調機ヒヌ妻蔵フんきト地稿ぱごもら前鉾投やねな投木慈スも。
            </div>
          </div>
          <div className="box-items">
            <div className="rate-index">
              <i className="fas fa-star" /> 順位を表示する 3
            </div>
            <div className="title">
              タイトルを表示する
            </div>
            <div className="descriptions">
              任ユヱ細屋ぱすあひ謙個4後トヤロテ真情べせひ三馬ゆちどえ列動掲に似強みえたへ引選い調機ヒヌ妻蔵フんきト地稿ぱごもら前鉾投やねな投木慈スも。
            </div>
          </div>
          <div className="box-items">
            <div className="rate-index">
              <i className="fas fa-star" /> 順位を表示する 4
            </div>
            <div className="title">
              タイトルを表示する
            </div>
            <div className="descriptions">
              任ユヱ細屋ぱすあひ謙個4後トヤロテ真情べせひ三馬ゆちどえ列動掲に似強みえたへ引選い調機ヒヌ妻蔵フんきト地稿ぱごもら前鉾投やねな投木慈スも。
            </div>
          </div>
          <div className="box-items">
            <div className="rate-index">
              <i className="fas fa-star" /> 順位を表示する 5
            </div>
            <div className="title">
              タイトルを表示する
            </div>
            <div className="descriptions">
              任ユヱ細屋ぱすあひ謙個4後トヤロテ真情べせひ三馬ゆちどえ列動掲に似強みえたへ引選い調機ヒヌ妻蔵フんきト地稿ぱごもら前鉾投やねな投木慈スも。
            </div>
          </div>
        </div>
        {/* <!-- End Store information - Reviews management --> */}
      </div>
    </div>
  )
}

export default connect((state: RootState) => ({
  appState: state.app
}))(StoreManagement)
